import "./Hero.css"

export default function Hero() {
  return (
    <div className="flex">
      <img src="/s.png" alt="كورس Next.js" className="w-64 h-64 object-contain mb-6" />
      <h1 className="h1"> Next.js كورس</h1>
    
    </div>
  );
}
